import type { AvailableResult } from './../available-result';
import type { Computation } from './../computation';
import type { Distribution } from './../../distributions/distribution';
import type { TestDistribution } from './test-distribution';
import type { _AvailableResult } from './../available-result';
import type { _Distribution } from './../../distributions/distribution';

/** 
 * Translated from class com.dataiku.dip.eda.compute.computations.univariate.FitDistribution
 * Via: UIModel annotation in the class hierarchy
 */
export interface _FitDistribution extends Computation._UnivariateComputation {
    type: "fit_distribution";
    distribution: Distribution;
    test: boolean;
}

export type FitDistribution = _FitDistribution;

export namespace FitDistribution {
    /** Type of class com.dataiku.dip.eda.compute.computations.univariate.FitDistribution in PolyJSON mappings */
    export const type = "fit_distribution";
    
    /** 
     * Translated from class com.dataiku.dip.eda.compute.computations.univariate.FitDistribution$FitDistributionResult
     * Via: UIModel annotation in the class hierarchy
     */
    export interface _FitDistributionResult extends _AvailableResult {
        type: "fit_distribution";
        fit: Distribution.FittedDistribution;
        test?: TestDistribution.TestDistributionResult | null;
    }
    
    export type FitDistributionResult = _FitDistributionResult;

    export namespace FitDistributionResult {
        /** Type of class com.dataiku.dip.eda.compute.computations.univariate.FitDistribution$FitDistributionResult in PolyJSON mappings */
        export const type = "fit_distribution";
    }
}